import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuthLink } from '../auth/AuthContext';
import AuthShell from '../auth/AuthShell';
import Spinner from '../components/Spinner';
import Avatar from '../components/Avatar';
import SocialIcon from '../components/SocialIcon';
import RegistrationAgreements from '../components/RegistrationAgreements';
import api from '../api';

const names = { yandex: 'Яндекс ID', vk: 'VK ID', google: 'Google', telegram: 'Telegram' };
export default function SocialEmailPage() {
    const [params] = useSearchParams();
    const pending = params.get('pending') || '';
    const [state, setState] = useState('loading');
    const [profile, setProfile] = useState(null);
    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const [agreements, setAgreements] = useState(null);
    useEffect(() => {
        let active = true;
        setState('loading'); setError(null); setAgreements(null);
        api.get('/api/auth/social-registration', { params: { pending } })
            .then(({ data }) => { if (active) { setProfile(data); setEmail(data.email || ''); setAgreements(data.approvedAgreements || null); setState('form'); } })
            .catch(() => { if (active) setState('expired'); });
        return () => { active = false; };
    }, [pending]);
    const submit = async event => {
        event.preventDefault();
        if (busy || !agreements) return;
        setBusy(true); setError(null);
        try {
            await api.get('/api/auth/csrf');
            const response = await api.post('/api/auth/social-registration', { pending, email, agreements });
            window.location.assign(response.data.targetUrl);
        } catch (failure) {
            const detail = failure.response?.data?.detail;
            if (failure.response?.status === 409) setError(detail || 'Не удалось создать аккаунт. Если он уже существует, войдите и привяжите провайдера в разделе безопасности.');
            else setError(detail || 'Не удалось завершить регистрацию. Проверьте данные и попробуйте снова.');
            setBusy(false);
        }
    };
    if (state === 'loading') return <AuthShell title="Завершение регистрации"><Spinner /></AuthShell>;
    if (state === 'expired') return <AuthShell title="Вход прерван"><p className="auth-description">Запрос устарел. Начните вход заново.</p><AuthLink to="/login" className="auth-back">К авторизации</AuthLink></AuthShell>;
    const provider = names[profile.provider] || profile.provider;
    const identity = <div className="auth-social-identity" aria-label={`Профиль ${provider}`}>
        <div className="auth-identity-avatar"><Avatar src={profile.picture} name={profile.name} email={email} size={64} /></div>
        <div className="auth-identity-provider"><SocialIcon provider={profile.provider} size={36} /></div>
    </div>;
    return <AuthShell title="Создаём аккаунт" identity={identity} variant="registration">
        <p className="auth-description">Вы входите через {provider} впервые. {profile.approvedAgreements ? 'Условия уже подтверждены. Завершите создание аккаунта.' : 'Подтвердите условия создания аккаунта.'}</p>
        <form onSubmit={submit} className="flex flex-col gap-5">
            {profile.email ? <p className="auth-registration-email">{profile.email}</p> : <><p className="auth-description">Провайдер не передал почту. Укажите адрес: его нужно будет подтвердить письмом.</p><input type="email" aria-label="Email" placeholder="Email" autoComplete="email" maxLength={254} required disabled={busy} value={email} onChange={event => setEmail(event.target.value)} /></>}
            {!profile.approvedAgreements && <RegistrationAgreements key={pending} onChange={setAgreements} disabled={busy} />}
            {error && <p className="auth-error" role="alert">{error}</p>}
            <button type="submit" className="auth-primary" disabled={busy || !agreements}>{busy ? 'Создаём аккаунт…' : `Продолжить с ${provider}`}</button>
        </form>
        <AuthLink to="/register" className="auth-back mt-4">Зарегистрироваться по почте</AuthLink>
        <AuthLink to="/login" className="auth-back mt-3">Войти в существующий аккаунт</AuthLink>
    </AuthShell>;
}
